export default {
  BROUILLON: 0,
  PLANIFIER: 1,
  CONFIRMER: 2,
  REFUSER: 3,
  EFFECTUER: 4,

  TXT_BROUILLON: 'Brouillon',
  TXT_PLANIFIER: 'Planifié',
  TXT_CONFIRMER: 'Confirmé',
  TXT_REFUSER: 'Refusé',
  TXT_EFFECTUER: 'Effectué',

  C_ATTENTE: 0,
  C_CONFIRMER: 1,
  C_REFUSER: 2,
  C_TERMINER: 3,

  TXT_C_ATTENTE: 'En attente',
  TXT_C_CONFIRMER: 'Confirmé',
  TXT_C_REFUSER: 'Refusé',
  TXT_C_TERMINER: 'Terminé',
};
